import { render, staticRenderFns } from "./PDFGenerator.vue?vue&type=template&id=68505d54&scoped=true&"
import script from "./PDFGenerator.vue?vue&type=script&lang=js&"
export * from "./PDFGenerator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68505d54",
  null
  
)

export default component.exports